<template>
    <div style="line-height: 1.4em;">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row dense>
            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon></v-btn>
        </v-row>
       <v-card  v-for="(student, index) in students" :key="index" class="box card" flat >
            <v-col cols="12" sm="12" md="12">
                <v-row justify="center" class="pb-0">
                    <v-col cols="12" sm="2" md="2">
                        <v-row v-if="org_basic_data.school_logo" dense justify="center">
                            <img :src="org_basic_data.school_logo" width="80%" alt="logo" />
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="8" md="8" style="line-height: 170%;">
                        <v-row v-if="org_basic_data.trust_name" dense justify="center">
                            <h4>{{ org_basic_data.trust_name }}</h4>
                        </v-row>
                        <v-row dense v-if="org_basic_data.school_name" class="pt-1 pb-1" justify="center">
                            <h1>{{ org_basic_data.school_name }}</h1>
                        </v-row>
                        <v-row v-if="org_basic_data.address" dense justify="center">
                            <h4>{{ org_basic_data.address }}</h4>
                        </v-row>
                        <v-row dense justify="center" v-if="org_basic_data.email && org_basic_data.phone">
                            <h4>
                                Phone : {{ org_basic_data.phone }} Email : {{ org_basic_data.email }}
                            </h4>
                        </v-row>
                        <v-row v-if="org_basic_data.website" dense justify="center">
                            <h4>Website : {{ org_basic_data.website }}</h4>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-row v-if="org_basic_data.trust_logo" dense justify="center">
                            <img :src="org_basic_data.trust_logo" width="75%" alt="logo" />
                            <span v-if="org_basic_data.cbsc_no">
                                <h5>CBSE Affiliation No. - {{ org_basic_data.cbsc_no }}</h5>
                            </span>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row dense justify="center" class="tech-remark">
                    <span class="text_report">
                        <strong><v-col cols="12" sm="12" md="12"> Report Card A.Y. {{ student.ay }}</v-col> </strong>
                    </span>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="10" md="10">
                        <v-row dense style="line-height: 1.6em;" class="stud-info">
                            <v-col cols="12" sm="6" md="6"><strong>Name : </strong> {{ student.name }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Roll No. : </strong> {{ student.roll_no }} </v-col>
                            <v-col cols="12" sm="6" md="6"><strong>Grade & Section : </strong>{{ student.standard }} {{ student.div }} </v-col>
                            <v-col cols="12" sm="6" md="6"><strong>PRN : </strong>{{ student.reg_no }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Date Of Birth : </strong> {{ student.dob }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>G.R. No. : </strong> {{ student.gr_no }}</v-col>
                            <v-col cols="12" sm="6" md="6"><strong>Father's Name : </strong> {{ student.father_full_name }} </v-col>
                            <v-col cols="12" sm="6" md="6"><strong>Father's Contact No. : </strong> {{ student.father_contact }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Mother's Name : </strong> {{ student.mother_name }} </v-col>
                            <v-col cols="12" sm="6" md="6"> <strong>Mother's Contact No. : </strong> {{ student.mother_contact }} </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-if="student.photo != null">
                        <img :src="awspath + student.photo" style="width: 160px; height: 160px;" alt="logo" />
                    </v-col>
                    <v-col cols="12" sm="2" md="2" v-else>
                        <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/User_avatar.jpeg" style="width: 160px; height: 160px;" alt="logo" />
                    </v-col>
                </v-row>
                <v-row dense class="stud-info" style="text-indent: -1.5em; padding-left: 1.5em;">
                    <v-col cols="12" sm="12" md="12"> <strong>Residential Address : </strong> {{ student.address }} </v-col>
                </v-row>
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td :colspan=" 5 * student.leraner_marksheet.ass_details_for_marksheet.length"
                                >
                                    <center>Scholastic Areas : {{ student.semester }}</center>
                                </td>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <td class=""><center>Subject Name</center></td>
                                <td class="" v-for="header in student.leraner_marksheet.ass_details_for_marksheet" :key="header">
                                    <center>{{ header }}</center>
                                </td>
                                <td class="">
                                    <center>
                                        Total({{ student.leraner_marksheet.converted_marks[0] }})
                                    </center>
                                </td>
                                <td class=""><center>Grade</center></td>
                                <td class=""><center>Overall Grade</center></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="s in student.leraner_marksheet.leraner_marksheet" :key="s.lcm_id">
                                <td align="left">{{ s.crs_name }}</td>
                                <td v-for="(header, index) in s.all_marks" :key="index">
                                    <center>{{ header }}</center>
                                </td>
                                <td>
                                    <center>{{ s.total_marks }}</center>
                                </td>
                                <td>
                                    <center>{{ s.grade }}</center>
                                </td>
                                <td>
                                    <center>{{ s.overall_grade }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-row dense justify="center" v-if="student.leraner_marksheet.show_grade == 'YES'">
                  <span class="text_report"> 
                    <v-col cols="12" sm="12" md="12"> 
                    <strong> 
                   Overall (All Subject) Percentage : {{ student.leraner_marksheet.overall_grade[1] }}
                        </strong>
                        </v-col>
                    </span>
                    <span class="text_report"> 
                            <v-col cols="12" sm="12" md="12"> 
                            <strong> Overall (All Subject) Grade : {{ student.leraner_marksheet.overall_grade[0] }}
                        </strong>
                        </v-col>
                    </span>
                </v-row>
                <v-row dense justify="center"  v-else>
                    <span class="text_report">
                    <strong><v-col cols="12" sm="12" md="12"> Overall (All Subject) Grade : {{ student.leraner_marksheet.overall_grade[0] }}</v-col> </strong>
                    </span>
                </v-row>
                
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table fixed-header dense class="elevation-1" v-if="student.leraner_marksheet.leraner_coscholastic_marksheet.length > 0">
                        <thead>
                            <tr>
                                <td colspan="3">
                                    <center>Co-Scholastic Areas : {{ student.semester }}</center>
                                </td>
                            </tr>
                        </thead>
                        <thead>
                            <tr>
                                <td align="center">Subject Name</td>
                                <td align="center">Grade</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="s in student.leraner_marksheet.leraner_coscholastic_marksheet" :key="s.lcm_id">
                                <td align="left">{{ s.crs_name }}</td>
                                <td>
                                    <center>{{ s.grade }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="student.leraner_marksheet.leraner_other_marksheet.length > 0">
                    <v-simple-table fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td class=""><center>Subject Name</center></td>
                                <td class=""><center>Grade</center></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="s in student.leraner_marksheet.leraner_other_marksheet" :key="s.lcm_id">
                                <td align="left">{{ s.crs_name }}</td>
                                <td>
                                    <center>{{ s.grade }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="student.leraner_marksheet.display_bmi == 'True'">
                    <v-simple-table v-if="student.leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <tr>
                            <td rowspan="3">
                                <center><strong>Health Status</strong></center>
                            </td>
                        </tr>
                        <tr>
                            <td><center>Height(cm)</center></td>
                            <td><center>Weight(kg)</center></td>
                            <td><center>BMI</center></td>
                        </tr>
                        <tr>
                            <td v-for="(s, index2) in student.leraner_marksheet.user_bmi_list_sem" :key="index2">
                                <center>{{ s }}</center>
                            </td>
                        </tr>
                    </v-simple-table>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="student.leraner_marksheet.display_att == 'True'">
                    <v-simple-table v-if="student.leraner_marksheet != ''" fixed-header dense class="elevation-1">
                        <thead>
                            <tr>
                                <td><center>Total Attendance</center></td>
                                <td>
                                    <center>{{ student.leraner_marksheet.sem1 }}</center>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <center>
                                        <strong>Total Attendance of the Student</strong>
                                    </center>
                                </td>
                                <td v-for="(s, index2) in student.leraner_marksheet.sem_attendance" :key="index2">
                                    <center>{{ s.present }}</center>
                                </td>
                            </tr>
                            <tr v-if="!student.hide_working_days_in_table"> 
                                <td>
                                    <center><strong>Total Working Days</strong></center>
                                </td>
                                <td v-for="(s, index2) in student.leraner_marksheet.sem_attendance" :key="index2">
                                    <center>{{ s.total_working_stud }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>

                <v-col cols="12" sm="12" md="12" style="line-height: 150%;" class="tech-remark">
                    <strong>Class Teacher's Remarks : </strong>
                    {{ student.leraner_marksheet.lms_remark }}
                </v-col>
                <br />
                <v-col cols="12" sm="12" md="12">
                    <v-row dense justify="center" class="tech-remark">
                        <v-col cols="12" sm="4" md="4">
                            Date - {{ student.leraner_marksheet.lms_result_date }}
                        </v-col>
                        <v-col cols="12" sm="4" md="4"> Signature of Class Teacher </v-col>
                        <v-col cols="12" sm="4" md="4"> Signature of Principal </v-col>
                    </v-row>
                </v-col>

                <div class="pagebreak">
                    <br />
                    <br />
                    <v-row dense justify="center" class="mb-2">
                        <span class="text_report">
                            <strong><v-col cols="12" sm="12" md="12" style="width: 400px;"> Scholastic Areas (Grading on {{ student.leraner_marksheet.scholastic_grade }} Point Scale)</v-col> </strong>
                        </span>
                    </v-row>
                    <v-row dense justify="center">
                        <v-simple-table fixed-header dense class="elevation-1 mb-2" style="width: 400px;">
                            <thead>
                                <tr>
                                    <td class=""><center>Sr. No.</center></td>
                                    <td class=""><center>Grade Name</center></td>
                                    <td class=""><center>Percentage Range</center></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in student.leraner_marksheet.grade_details" :key="s.g_id">
                                    <td>
                                        <center>{{ index + 1 }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.gradename }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.range }}</center>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-row>
                    <v-row dense justify="center" v-if="student.leraner_marksheet.cograde_details.length > 0" class="mb-2">
                        <span class="text_report">
                            <strong><v-col cols="12" sm="12" md="12" style="width: 400px;"> Co-Scholastic Areas (Grading on {{ student.leraner_marksheet.coscholastic_grade }} Point Scale)</v-col> </strong>
                        </span>
                    </v-row>
                    <v-row dense justify="center" v-if="student.leraner_marksheet.cograde_details.length > 0" class="mb-2">
                        <v-simple-table fixed-header dense class="elevation-1" style="width: 400px;">
                            <thead>
                                <tr>
                                    <td class=""><center>Sr. No.</center></td>
                                    <td class=""><center>Grade Name</center></td>
                                    <td class=""><center>Grade Point</center></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(s, index) in student.leraner_marksheet.cograde_details" :key="s.g_id">
                                    <td>
                                        <center>{{ index + 1 }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.gradename }}</center>
                                    </td>
                                    <td>
                                        <center>{{ s.range }}</center>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-row>
                    <v-col cols="12" sm="12" md="12" class="tech-remark">
                        1. Student must obtain the qualifying grade (minimum grade D) in all the subjects under Scholastic domain.<br />
                    </v-col>
                </div>
            </v-col>
        </v-card>
         <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import jsPDF from "jspdf";
    import "jspdf-autotable";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        props: {
            org: Number,
        },
        data() {
            return {
                default_value: [],
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                semester_list: null,
                sem: null,
                fetch_loader: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                standard: null,
                div: null,
                ay: null,
                name: null,
                students: [],
                semester: null,
                colspan: null,
                remark: [],
                org_basic_data: [],
            };
        },

        methods: {
            // print() {
            //     this.$store.state.drawer = false;
            //     let that = this;
            //     window.onafterprint = function () {
            //         that.$store.state.drawer = true;
            //     };
            //     setTimeout(function () {
            //         window.print();
            //     }, 100);
            // },
            print() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                this.overlay = true;
                const data = {
                    ay: this.sel_ay_data,
                    sem: this.sem,
                    standard: this.std,
                    division: this.div,
                    org: this.org,
                    status: this.status,
                };
                axios
                    .post("/Examination/getBulkStudentReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.students = res.data.students;
                            this.semester = res.data.semester;
                            this.org_basic_data = res.data.org_basic_data;
                            this.overlay = false;
                        }else{
                            this.showSnackbar("#b71c1c", "Something went wrong..."); 
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); 
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.sel_ay_data = localStorage.getItem("setay");
            this.sem = localStorage.getItem("setsem");
            this.registration_no = localStorage.getItem("setreg_no");
            this.tenant = localStorage.getItem("EPS-tenant");
            this.std = localStorage.getItem("setstd");
            this.div = localStorage.getItem("setdiv");
            this.org = localStorage.getItem("EPS-org-id");
            this.status = localStorage.getItem("status");
            this.onload();
        },
    };
</script>
<style scoped>
    .text_report {
        border: 2px solid black;
        margin: 6px !important;
    }
    thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        font-size: small;
    }
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }

    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    @page {
        size: A4;
        margin-top: none;
        padding-top: none;
        margin: 0;
        size: 12in 16.8in;
    }
    
    @media print and (-webkit-min-device-pixel-ratio: 0) {
        .v-data-table__wrapper {
            overflow-x: hidden;
            overflow-y: hidden;
        }
        .card {
            border: none !important;
            font-size: medium !important;
            padding: 30px !important;
            page-break-after: always !important;
            break-after: page !important;
        }
        .card:last-child {
            page-break-after: auto !important;
            break-after: auto !important;
        }
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
        }

        table,
        td,
        tr {
            break-inside: avoid-page;
            page-break-inside: auto;
        }

        body,
        tr,
        th,
        td {
            font-size: 18px !important;
            page-break-inside: auto;
            padding: 0 !important;
            word-wrap: break-word;
            margin: 0 !important;
        }
        td {
            font-size: 18px !important;
            padding: 1mm !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }

        thead {
            font-weight: bold !important;
        }
        table,
        tr,
        th {
            text-align: center !important;
            margin-top: none;
            padding: none !important;
            border-bottom: 1px solid black;
            border: 1px solid black;
            page-break-inside: auto;
        }
        .div {
            width: 1700px !important;
            font-size: small;
            margin: 0 !important;
            border: 0px solid black;
        }

        h5{
            font-size: 10px;
        }
    }
    ol.s {
        list-style-type: inherit;
    }
    .stud-info strong {
        margin-left: 20px;
    }
    .stud-info {
        font-size: 20px !important;
    }
    .tech-remark {
        font-size: 20px !important;
    }
</style>
